import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'dcp-empty-cart-set-focus',
  templateUrl: './empty-cart-set-focus.component.html',
  styleUrls: ['./empty-cart-set-focus.component.scss'],
})
export class EmptyCartSetFocusComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) public platformId: object) {}

  ngOnInit(): void {
    this.focusSap4meBtn();
  }

  focusSap4meBtn() {
    if (isPlatformBrowser(this.platformId)) {
      const returnToSap4meBtn = document.querySelector<HTMLElement>('.btn.btn-primary.btn-return-sap4me');
      if (returnToSap4meBtn) {
        returnToSap4meBtn.focus();
      }
    }
  }
}
